import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ExamReportsClient } from 'src/app/generated-client/generated-api-client';

@Component({
  selector: 'app-exam-report-results-tab',
  templateUrl: './exam-report-results-tab.component.html',
  styleUrls: ['./exam-report-results-tab.component.sass'],
})
export class ExamReportResultsTabComponent implements OnInit {
  id: string = '';

  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private router: Router,
    private _examReportClient: ExamReportsClient
  ) {
    route.parent?.paramMap.subscribe(next => {
      this.id = next.get('id') ?? '';
    });
  }

  ngOnInit(): void {
    this._examReportClient.get(this.id).subscribe(examReport => {
      this.titleService.setTitle(examReport.identifier + ' - eredményei');
    });
  }
}
